import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { haversineKm } from "@/lib/format";

const BranchContext = createContext(null);

export function BranchProvider({ children }) {
  const [branches, setBranches] = useState([]);
  const [branch, setBranchState] = useState(null);
  const [coords, setCoords] = useState(() => {
    try { return JSON.parse(localStorage.getItem("fas_coords")); } catch { return null; }
  });

  useEffect(() => {
    api.get("/branches").then((r) => setBranches(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (branches.length === 0) return;
    const saved = localStorage.getItem("fas_branch_id");
    setBranchState(branches.find((b) => b.id === saved) || branches[0]);
  }, [branches]);

  const setBranch = (b) => {
    setBranchState(b);
    localStorage.setItem("fas_branch_id", b.id);
  };

  const detectLocation = () => new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("GPS tidak didukung browser"));
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const c = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        setCoords(c);
        localStorage.setItem("fas_coords", JSON.stringify(c));
        if (branches.length) {
          const nearest = [...branches].sort(
            (a, b) => haversineKm(c.lat, c.lng, a.lat, a.lng) - haversineKm(c.lat, c.lng, b.lat, b.lng)
          )[0];
          setBranch(nearest);
          resolve({ coords: c, branch: nearest });
        } else {
          resolve({ coords: c, branch: null });
        }
      },
      (err) => reject(err),
      { timeout: 10000 }
    );
  });

  const distanceKm = branch && coords ? haversineKm(coords.lat, coords.lng, branch.lat, branch.lng) : null;

  return (
    <BranchContext.Provider value={{ branches, branch, setBranch, coords, detectLocation, distanceKm }}>
      {children}
    </BranchContext.Provider>
  );
}

export const useBranch = () => useContext(BranchContext);
